module.exports = __webpack_public_path__ + "static/img/performance-statistics.d98ec5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/performance-statistics.png
// module id = 2RAM
// module chunks = 1